
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Firstpage from "./Componanat/Firstpage.jsx";
import Termspage from './Componanat/Termspage.jsx'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default "/" se redirect */}
        <Route path="/" element={<Navigate to="/partner" />} />

        {/* Movers page */}
        <Route path="/partner" element={<Firstpage />} />
        <Route path="/Terms-&-Conditions" element={<Termspage />} />

        
      </Routes>
    </BrowserRouter>
  );
}

export default App;